import Route from 'mewe/routes/route';
import { inject as service } from '@ember/service';

// deprecated - to be removed after some grace period
export default class PostRoute extends Route {
  @service router;

  beforeModel(transition) {
    const params = transition.to.params;
    if (params && params.post_id) {
      this.router.transitionTo('app.myworld.single-post', params.post_id);
    }
  }
}
